import { useQuery } from '@tanstack/react-query';

import OffersService from '~/services/OffersService';

export const offerTemplateQueryKeys = {
  all: ['offer-templates'] as const,
  approved: () => [...offerTemplateQueryKeys.all, 'approved'] as const,
};

export function useGetOfferTemplates() {
  return useQuery({
    queryKey: offerTemplateQueryKeys.approved(),
    queryFn: async () => {
      const response = await OffersService.getOfferTemplates();
      return response.filter((template) => template.status === 'approved');
    },
  });
}
